import type { Job } from "../types/Job";
import type { Deal } from "@domain/CRM/deal";

/**
 * Apply deal fields to a job (mutates the job in place).
 *
 * The class method `Job.updateFromDeal(job, deal)` is a pass-through to this
 * function; consumers can call either form.
 */
export function updateJobFromDeal(job: Job, deal: Deal): void {
	job.importDensity = deal.density;
	job.importDepth = deal.depth;
	const testPackage = deal.testPackage || "No test package specified";
	job.externalTestPackageId = Array.isArray(testPackage) ? testPackage.join("") : testPackage;
	job.externalFrequencyOfMicros = deal.frequencyOfMicros ?? 0;
}
